import { ButtonArrowState, Divider, Markdown, PrimaryButton, SecondaryButton } from '@huggg/react-components'

import React, { useMemo } from 'react';
import styles from './guided-choice.module.scss';
import ProductCard from 'components/ui/ProductCard/ProductCard';

export const GuidedChoiceResult = props => {
    const { segments, markdown, segmentId, cta, onBackClick, onCtaClick } = props;


    const segment = useMemo(() => segments.find(seg => seg.id === segmentId) ?? null, [segments, segmentId]);

    return <div className={styles.layout}>
        <ProductCard
            title={segment.name}
            imageUrls={segment.images}
            hidePoweredBy={true}
            centerText={true}
        />
        <Divider style={{ marginTop: 0 }}></Divider>
        <Markdown value={markdown} />

        <div className={styles.buttonBlock}>
            <PrimaryButton
                data-test-id={`result-cta-button-${segmentId}`}
                label={cta}
                onClick={() => onCtaClick(segment)}
            />
            <SecondaryButton
                label='Go back'
                arrow={ButtonArrowState.Backwards}
                onClick={onBackClick}
            />
        </div>
    </div>
}